import { LOCALE_PATH } from './config';

let phrases = {};
const loadedFiles = new Set();

export async function loadLocaleFile(fileName) {
  if (loadedFiles.has(fileName)) return;
  const cacheBust =
    process.env.NODE_ENV === 'development' ? `?v=${Date.now()}` : '';
  const url = `${LOCALE_PATH}${fileName}.json${cacheBust}`;

  try {
    const res = await fetch(url);
    if (!res.ok) {
      console.warn(
        `No se pudo cargar archivo de idioma: ${fileName} (${res.status})`
      );
      return;
    }

    const text = await res.text();
    const data = JSON.parse(text);
    phrases = { ...phrases, ...data };
    loadedFiles.add(fileName);
  } catch (err) {
    console.error(`Error cargando idioma (${fileName}):`, err);
  }
}

export function t(key) {
  return phrases[key] || key;
}
